import React, { useMemo } from 'react'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { BasePublisherCheckbox } from '../checkbox/base-publisher-checkbox'
import { CheckboxesErrorsType, useFormContext } from './context/form-context'

interface FormCheckboxSubEntityProps {
  formEntity: FormInterface
  checkboxSubEntity: FormCheckboxInterface
}

export const FormCheckboxSubEntity = ({
  formEntity,
  checkboxSubEntity,
}: FormCheckboxSubEntityProps) => {
  const { checkboxesValues, setCheckboxesValues, setCheckboxesErrors } =
    useFormContext()
  const entity = useMemo(
    () => ({
      ...checkboxSubEntity,
      ...formEntity.checkboxesCommonStyles,
    }),
    [checkboxSubEntity, formEntity.checkboxesCommonStyles],
  )
  return (
    <BasePublisherCheckbox
      entityOrSubEntity={entity}
      checked={checkboxesValues[checkboxSubEntity.id]}
      onChange={() => {
        setCheckboxesValues(prev => ({
          ...prev,
          [checkboxSubEntity.id]: !prev[checkboxSubEntity.id],
        }))
        setCheckboxesErrors(prev =>
          Object.entries(prev).reduce((acc, [key, value]) => {
            if (key !== checkboxSubEntity.id) {
              acc[key] = value
            }
            return acc
          }, {} as CheckboxesErrorsType),
        )
      }}
    />
  )
}
